import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_USERS } from "../../../utils/constants";
import { UserInterface } from "../../../models/UserModel/User";
import userService from "../../../services/userService/userService";

interface AddUsersContext {
  previousUsers: UserInterface[];
}

const useAddUsers = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<UserInterface, Error, UserInterface, AddUsersContext>({
    mutationFn: userService.Save,

    onMutate: () => {
      const previousUsers =
        queryClient.getQueryData<UserInterface[]>([
          CACHE_KEY_USERS,
          page,
          pageSize,
        ]) || [];

      return { previousUsers };
    },

    onSuccess: (savedUsers) => {
      queryClient.setQueryData<UserInterface[]>(
        [CACHE_KEY_USERS, page, pageSize],
        (users) => (users ? [savedUsers, ...users] : [savedUsers])
      );
    },

    onError: (error, newUser, context) => {
      if (!context) return;

      queryClient.setQueryData<UserInterface[]>(
        [CACHE_KEY_USERS, page, pageSize],
        context.previousUsers
      );
    },
  });
};

export default useAddUsers;
